export type PaymentMethod = 'billing' | 'card';

export type PaymentMethodOptions = 'invoice' | 'card' | 'selectable';

export type PaymentGateway = 'gmo' | 'sony' | '';

export const PAYMENT_METHODS = {
  BILLING: 'billing',
  CARD: 'card'
} as const;

export const PAYMENT_METHOD_OPTIONS = {
  INVOICE: 'invoice',
  CARD: 'card',
  SELECTABLE: 'selectable'
} as const;

export const PAYMENT_GATEWAYS = {
  GMO: 'gmo',
  SONY: 'sony',
  NONE: ''
} as const;

export const NEW_CARD_UID = 'new';

export type PaymentGatewayMember = {
  uid: string;
  name: string;
  masked_credit_card_number: string;
};

export type PaymentInfo = {
  paymentMethodOptions: PaymentMethodOptions;
  gatewayType: PaymentGateway;
  gatewayMembers: PaymentGatewayMember[];
  gmoShopId: string;
  gmoTokenHost: string;
};

export type PaymentCardInput = {
  cardNumber1: string;
  cardNumber2: string;
  cardNumber3: string;
  cardNumber4: string;
  expireMonth: string;
  expireYear: string;
  holderName: string;
  securityCode: string;
};

export type PaymentFormState = {
  paymentMethod: PaymentMethod;
  // クレカ選択時に使うカード。既存カードは uid、新規入力は NEW_CARD_UID。
  selectedCardUid: string | typeof NEW_CARD_UID | null;
  cardInput: PaymentCardInput;
};

export const EMPTY_CARD_INPUT: PaymentCardInput = {
  cardNumber1: '',
  cardNumber2: '',
  cardNumber3: '',
  cardNumber4: '',
  expireMonth: '',
  expireYear: '',
  holderName: '',
  securityCode: ''
};

export const joinCardNumber = (input: PaymentCardInput): string =>
  `${input.cardNumber1}${input.cardNumber2}${input.cardNumber3}${input.cardNumber4}`;

export const isCardInputComplete = (input: PaymentCardInput): boolean =>
  Object.values(input).every(value => value.trim() !== '');
